const FLUID_TYPE_OIL_QUOTED = '"oil"';
const FLUID_TYPE_GAS_QUOTED = '"gas"';

function normalizeFluidTypeForApi(raw) {
  if (raw == null) return null;
  const s = Array.isArray(raw) ? raw[0] : raw;
  const t = String(s).trim();
  if (!t) return null;
  const inner = t.replace(/^["']+|["']+$/g, "").toLowerCase();
  if (inner === "oil") return FLUID_TYPE_OIL_QUOTED;
  if (inner === "gas") return FLUID_TYPE_GAS_QUOTED;
  return t;
}

export function scorecardDatasetLabelToApiFilters(datasetLabel) {
  const label = String(datasetLabel || "").trim();
  const lower = label.toLowerCase();
  if (label === "DL Dataset" || lower === "dl dataset") {
    return { selectedTests: ["dltests"], fluidType: FLUID_TYPE_OIL_QUOTED };
  }
  if (label === "CCE Dataset (Gas)" || lower.includes("(gas)")) {
    return { selectedTests: ["ccetests"], fluidType: FLUID_TYPE_GAS_QUOTED };
  }
  return { selectedTests: ["ccetests"], fluidType: FLUID_TYPE_OIL_QUOTED };
}

export function matrixContextToApiFilters(matrixTestContext) {
  if (String(matrixTestContext || "").toLowerCase() === "dl") {
    return { selectedTests: ["dltests"], fluidType: FLUID_TYPE_OIL_QUOTED };
  }
  return { selectedTests: ["ccetests"], fluidType: FLUID_TYPE_OIL_QUOTED };
}

export function parseSamplesListQueryFromRouteQuery(query) {
  if (!query || typeof query !== "object") {
    return { selectedTests: null, fluidType: null };
  }
  const raw = query.selectedTests;
  const s = Array.isArray(raw) ? raw[0] : raw;
  let selectedTests = null;
  if (s != null && String(s).trim() !== "") {
    try {
      const v = JSON.parse(String(s));
      if (Array.isArray(v)) selectedTests = v.map((x) => String(x).toLowerCase());
    } catch {
      selectedTests = null;
    }
  }
  const fluidType = normalizeFluidTypeForApi(query.fluidType);
  return { selectedTests, fluidType };
}

export function routerQueryFromApiFilters(filters) {
  if (!filters) return {};
  const out = {};
  if (filters.selectedTests?.length) {
    out.selectedTests = JSON.stringify(filters.selectedTests);
  }
  if (filters.fluidType) {
    out.fluidType = filters.fluidType;
  }
  return out;
}

export function pickSamplesListQueryForRouter(query) {
  if (!query || typeof query !== "object") return {};
  const out = {};
  if (query.type != null && String(query.type) !== "") out.type = query.type;
  if (query.selectedTests != null && String(query.selectedTests) !== "") {
    out.selectedTests = query.selectedTests;
  }
  if (query.fluidType != null && String(query.fluidType) !== "") {
    out.fluidType = query.fluidType;
  }
  if (query.well != null && String(query.well) !== "") {
    out.well = query.well;
  }
  if (query.reportIdentifier != null && String(query.reportIdentifier) !== "") {
    out.reportIdentifier = query.reportIdentifier;
  }
  if (query.fluidSampleID != null && String(query.fluidSampleID) !== "") {
    out.fluidSampleID = query.fluidSampleID;
  }
  if (query.sampleId != null && String(query.sampleId) !== "") {
    out.sampleId = query.sampleId;
  }
  if (query.qaqcCtx != null && String(query.qaqcCtx) !== "") {
    out.qaqcCtx = query.qaqcCtx;
  }
  if (query.qaqcScreen != null && String(query.qaqcScreen) !== "") {
    out.qaqcScreen = query.qaqcScreen;
  }
  if (query.qaqcTab != null && String(query.qaqcTab) !== "") {
    out.qaqcTab = query.qaqcTab;
  }
  if (query.qaqcOverviewTab != null && String(query.qaqcOverviewTab) !== "") {
    out.qaqcOverviewTab = query.qaqcOverviewTab;
  }
  return out;
}

export function appendSamplesApiQueryParams(url, { selectedTests, fluidType }) {
  let next = url;
  if (selectedTests?.length) {
    next += `&selectedTests=${encodeURIComponent(JSON.stringify(selectedTests))}`;
  }
  if (fluidType) {
    next += `&fluidType=${encodeURIComponent(fluidType)}`;
  }
  return next;
}
